'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * How many parts of the dashboard hold something that would be lost right now; shared by all
 * dashboards on the page, which is one in practice.
 */
let unsavedParts = 0;

/** Whether leaving the current Hof would lose a form that is open, with what was typed. */
export const hasUnsavedWork = (): boolean => unsavedParts > 0;

/**
 * Asks the browser to confirm before the page is closed or reloaded while something would
 * be lost: a form opened on the dashboard, with its answers and uploads. The Hof select asks `hasUnsavedWork`
 * the same before it swaps the dashboard; a link within the site is not caught.
 */
export const useWarnBeforeLeaving = unsaved => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== unsaved) {
    t0 = () => {
      if (!unsaved) {
        return;
      }
      unsavedParts = unsavedParts + 1;
      const warn = _temp;
      globalThis.addEventListener("beforeunload", warn);
      return () => {
        unsavedParts = unsavedParts - 1;
        globalThis.removeEventListener("beforeunload", warn);
      };
    };
    t1 = [unsaved];
    $[0] = unsaved;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
function _temp(event) {
  return event.preventDefault();
}